<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <h2>ping.mss.io</h2>
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <Ping/>
    </v-main>
  </v-app>
</template>

<script>
import Ping from './components/Ping';

export default {
  name: 'App',

  components: {
    Ping,
  },

  data: () => ({
    //
  }),
};
</script>
